import React from 'react';

import { getViolationTypeLabel } from '../../../../utils/attendanceViolationHelpers';

const ViolationTypeChip = ({ violationType, compact, count }) => {
  const typeClass = violationType === 'EARLY_EXIT' ? 'exit' : 'late';
  const countNum = Number(count);
  const showCount = Number.isFinite(countNum) && countNum > 0;

  return (
    <span
      className={`att-violation-type-chip att-violation-type-chip--${typeClass}${
        compact ? ' att-violation-type-chip--compact' : ''
      }`}
    >
      {getViolationTypeLabel(violationType)}
      {showCount ? <span className="att-violation-type-chip__count">{countNum}</span> : null}
    </span>
  );
};

export default ViolationTypeChip;
